import { ajax } from "./api";

export const fetchPreviewUrls = (params, isGlass, isHandles) => {
    let url = "urlresolver";

    if (isGlass) {
        url += "/glassFamily";
    }
    else if(isHandles){
        url += "/handles";
    }

    return dispatch => {
        console.debug("GET", `enquiry/${url}`, params);
        ajax("GET", `enquiry/${url}`, params).then(data => {
            dispatch({
                type: "LOAD_IMAGE_PREVIEWS",
                payload: data.result.entity
            });
        });
    };
};

export const emptyPreviousPreviews = () => {
    return {
        type: "EMPTY_PREVIEWS"
    };
};



// WEBPACK FOOTER //
// ./src/actions/urlResolver.js